export default __webpack_public_path__ + "static/media/email.dacbc7e1.svg";